import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { NotificationsNoneOutlined } from '@mui/icons-material'
import { useIntl } from 'react-intl'

import theme from 'styles/theme'

// Desktop right-pane placeholder when no notification is selected
// (Figma "Powiadomienia" empty detail).
const NotificationsEmptyDetail: FC = () => {
  const { formatMessage } = useIntl()

  return (
    <Box
      sx={{
        flex: 1,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        px: '24px'
      }}>
      <NotificationsNoneOutlined
        sx={{ fontSize: '48px', color: theme.r4r.grey, opacity: 0.3 }}
      />
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 500,
          color: theme.r4r.grey,
          textAlign: 'center'
        }}>
        {formatMessage({
          id: 'notificationsList.selectToSeeDetails',
          defaultMessage: 'Wybierz powiadomienie, aby zobaczyć szczegóły'
        })}
      </Typography>
    </Box>
  )
}

export default NotificationsEmptyDetail
